import {PatchExamsConfirm, PatchExamsConfirmParams} from 'domain/usecases';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

export class RemotePatchExamsConfirm implements PatchExamsConfirm {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<unknown>,
	) {}

	async patch(params: PatchExamsConfirmParams): Promise<unknown> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'patch',
			body: params,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
